module.exports = __webpack_public_path__ + "img/lottery_button.6c83726d.png";